import React from "react";
import PolicyPage, { ContactEmail } from "./PolicyPage";

function Accessibility() {
  return (
    <PolicyPage title="Accessibility Statement">
      <h2>Our commitment</h2>
      <p>camartzuno aims to make its online store usable by people with a wide range of abilities, devices, and assistive technologies. Accessibility is an ongoing practice, and we review the site as content and technology change.</p>

      <h2>Measures we take</h2>
      <ul>
        <li>use semantic headings, labels, landmarks, and descriptive alternative text where appropriate;</li>
        <li>support keyboard navigation and visible focus states;</li>
        <li>consider text contrast, responsive layouts, zoom, and readable error messages; and</li>
        <li>seek accessible options when selecting or updating third-party services.</li>
      </ul>

      <h2>Known limitations</h2>
      <p>Some third-party payment, embedded, or legacy content may not provide the same level of accessibility. We do not control every external service, but we welcome reports and will look for a reasonable alternative when possible.</p>

      <h2>Request assistance or report a barrier</h2>
      <p>Email <ContactEmail /> with the page address, a description of the problem, the device and assistive technology used if you wish to share it, and your preferred contact method. You may also request product or policy information in a reasonable alternative format. We aim to acknowledge accessibility messages promptly.</p>

      <h2>Feedback</h2>
      <p>We value specific feedback and use it to prioritize improvements. This statement does not limit any accessibility right or remedy provided by applicable law.</p>
    </PolicyPage>
  );
}

export default Accessibility;
